import React from 'react';
import './VideoView.less';
import { Row, Item, Column } from 'react-plan';
import { default as Video, Controls, Overlay } from 'react-html5video';


export default (props) => {
  const videoUrl = (props.routeParams.videoId === 'engineering')
    ? '/videos/engineering.mp4'
    : '/videos/message.mp4';
  return (<Item>
    <Video controls autoPlay
      className="video-player">
      <Overlay />
      <Controls />
      <source src={videoUrl} />
    </Video>
  </Item>);

}



/** WEBPACK FOOTER **
 ** ./src/js/views/VideoView/VideoView.jsx
 **/